import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import { ThemeProvider } from "./components/theme-provider";
import Home from "./website-pages/home";
import StoryPage from "./website-pages/story";
import Team from "./website-pages/team";
import ClinicalEvidence from "./website-pages/clinical-evidence";
import NotFound from "./website-pages/not-found";
import Voices from "./website-pages/voices";
import StorySubmit from "./website-pages/story-submit";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/voices" component={Voices} />
      <Route path="/story/:id" component={StoryPage} />
      <Route path="/team" component={Team} />
      <Route path="/submit-story" component={StorySubmit} />
      <Route path="/clinical-evidence" component={ClinicalEvidence} />
      {/* Fallback to 404 */}
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="elevita-ui-theme">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
